<template>
  <v-ons-page>
    <div class="home-page justify-content-md-center" style="height:100%;">
      <div id="stats-banner">
        <b-row>
          <b-col>
            <div class="leftbox-header" @click="goTo('home')">
              <i class="fas fa-chevron-left"></i>
            </div>
          </b-col> 
          <b-col cols="8">
            <div class="middlebox-header">
              <h2>
                Min
                <b class="takt-success">
                  {{minLeadtime}} J
                </b> -
                Moyenne
                <b class="takt-mean">
                  {{avgLeadtime}} J
                </b> -
                Max
                <b class="takt-danger">
                  {{maxLeadtime}} J
                </b> 
              </h2>
              <div class="stats-more">
                <p>Voir toutes les cartes</p>
                <input
                  v-model="showAllCards"
                  @change="filterCheckBoxStateChanged"
                  type="checkbox"
                  id="checkbox"
                >
              </div>
            </div>
          </b-col>
          <b-col>
            <div class="rightbox-header" @click="changeVue" >
              <img src="../../assets/bouton-changer-de-vue.png" style="width:100%; height:auto; cursor:pointer;"/>
            </div>
          </b-col>
        </b-row>
      </div>
      <div id="andon-list">
        <b-container v-if="this.actualVue == 'classic' " fluid>
          <br>
          <b-row>
            <b-col lg v-for="(supplier, name, index) in internalSupplierList"
              :key="index"
              class="andon-col">
              <div class="header-list-kb">
                <h3 class="name-title"> {{name}} </h3> 
                <div class="number-kb-info">{{supplier.length}}</div>
              </div>
              <div v-for="element in supplier" :key="element.cardId"
                @contextmenu.prevent.stop="handleClick($event, element)"
                @click.prevent.stop="handleClick($event, element)"
                class="andon-card"
               >
                <BoardCard
                  :cardId = element.cardId
                  :computedLeadTime = computeLeadTime(element)
                  :cardContact = contactDefinition(element)
                  :askingDate = cellDelayAsk(element)
                  :cardDescription = element.descriptif
                  :andon = cellClass(element)
                  />  
              </div>
            </b-col>
          </b-row>
        </b-container>
        <b-container v-if="this.actualVue == 'andonList'" fluid>
          <br>
          <div class="header-list-kb">
            <div class="number-kb-info">{{andonKardcounter}}</div>
          </div>
          <div v-for="(element, index) in kanbanAndonList" :key="index"
            class="andon-card"
            @contextmenu.prevent.stop="handleClick($event, element)"
            @click.prevent.stop="handleClick($event, element)"
          >
          <BoardCard
              :cardId = element.cardId
              :computedLeadTime = computeLeadTime(element)
              :cardContact = contactDefinition(element)
              :askingDate = cellDelayAsk(element)
              :cardDescription = element.descriptif
              :andon = cellClass(element)
              :internalSupplier = element.internal_supplier
            />
          </div>
        </b-container>
        <b-container v-if="this.actualVue == 'statistique'" fluid>
          <b-button class="btn-csv" variant="dark" @click="exportCSV">export csv</b-button> 
          <DocumentStatGraph
            :series="this.dataScatterGraph.series"
            :categories="this.dataScatterGraph.categories"
            :colors = "['#3d71bf', '#4bc9b9', '#a04bd1']"
            v-if="finishLoop == true" 
          />
        </b-container>
        <reatribution-kanban-modal
          ref="reatribute-kanban"
          :customer="internalCustomer"
          :supplier="internalSupplier"
          :card="cardNumber"
          :office="office"
        >
        </reatribution-kanban-modal>
         <EndKanbanBeModal
          @saved="getKanbanCard"
          ref="end-kanban-be-modal"/> 
        <CancelKanbanBeModal
          @saved="getKanbanCard"
          ref="cancel-kanban-be-modal"/>
      </div>
    </div>
    <!-- context menu -->
    <VueSimpleContextMenu
      :elementId="'context-menu-andon'"
      :options="contextMenuList"
      :ref="'vueSimpleContextMenu'"
      @option-clicked="optionClicked"
    />
  </v-ons-page>
</template>
<script>

import server from '../../api/server.vue'
import moment, { invalid } from 'moment'
import { saveAs } from 'file-saver'
import ReatributionFormModal from '../modals/ReatributionFormModal'
import EndKanbanBeModal from '../modals/EndKanbanBeModal'
import CancelKanbanBeModal from '../modals/CancelKanbanBeModal.vue'
import CsvModalExport from '../modals/CsvModalExport.vue'
import BoardCard from './BoardCard'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import DocumentStatGraph from '../graph/DocumentStatGraph.vue'


export default {
  name: 'KanbanBoard',
  components: {
    'reatribution-kanban-modal': ReatributionFormModal,
    EndKanbanBeModal,
    CancelKanbanBeModal,
    VueSimpleContextMenu,
    CsvModalExport,
    BoardCard,
    DocumentStatGraph
  },
  data() {
    return {
      showAllCards: false,
      internalSupplierList: {},
      minLeadtime: 0,
      maxLeadtime: 0,
      avgLeadtime: 0,
      internalSupplier: '',
      internalCustomer: '',
      cardNumber: '',
      office: '',
      team: '',
      actualVue: 'classic',
      showAndonList: false,
      kanbanAndonList: [],
      finishLoop: false,
      contextMenuList: [
        {
        name: 'Marqué terminé',
        slug: 'end',
        class: 'end',
        },
        {
        name: 'Réaffecter le ticket',
        slug: 'reaf',
        class: 'reaf',
        },
        {
        name: 'Annuler le ticket',
        slug: 'cancel',
        class: 'cancel'
        },
      ],
      dataGraph:{
        series: [
          { name: 'Min', data: []},
          { name: 'Moyenne', data: []},
          { name: 'Max', data: []}
        ],
        categories: []
      },
      dataScatterGraph: {
        series: [
          {
           name: 'Temp de realisation des kanban',
           type: 'scatter',
           data:[]
           },
          {
           name: 'Moyenne du lead time',
           type: 'line',
           data:[]
          },
        ],
      }
    }
  },
  methods: {
    filterCheckBoxStateChanged() {
      this.getKanbanCard()
    },
    changeVue() {
      if (this.actualVue == 'classic') {
        this.actualVue = 'andonList'
      } else if (this.actualVue == 'andonList'){
        this.actualVue = 'statistique'
      } else {
        this.actualVue = 'classic'
      }
    },
    optionClicked (event) {
      const option = event.option.slug
      if (option === 'end') {
        this.$refs['end-kanban-be-modal'].showModal(event.item)
      } else if (option === 'reaf') {
        this.reatribuate(event.item)
      } else if (option === 'cancel') {

        this.$refs['cancel-kanban-be-modal'].showModal(event.item)
      }
    },
    handleClick (event, item) {
      this.$refs.vueSimpleContextMenu.showMenu(event, item)
    },
    cellClass (item) {
      const now = new Date()
      const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      if(Number.isNaN(Date.parse(item.delay_ask))){
        return true
      }
      if (Date.parse(today) > Date.parse(item.delay_ask)) {
        return true
      }
      else {
        return false
      }
    },
    contactDefinition (item) {
      if (item.customer) {
        return item.customer + ' (' + item.plant + ')'
      }
      else {
        return item.plant
      }
    },
    computeLeadTime (item) {
      const now = new Date()
      const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      if (Date.parse(today) > Date.parse(item.created_at)) {
        let diffTime = Math.abs(Date.parse(today) - Date.parse(item.created_at))
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays > this.maxLeadtime) {
          this.maxLeadtime = diffDays
        }
        if (diffDays < this.minLeadtime) {
          this.minLeadtime = diffDays
        }
        return diffDays+'j'
      }
      else {
        return '1j'
      }
    },
    cellDelayAsk (item) {
      if (item.delay_ask === null ) {
        return ''
      }
      return 'Pour le ' + moment(item.delay_ask).locale('FR').format('DD/MM/YY')
    },
    initiateMinAndMax () {
      const now = new Date()
      const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      for (const supplier in this.internalSupplierList){
        if(this.internalSupplierList[supplier].length > 0) {
          let diffTime = Math.abs(Date.parse(today) - Date.parse(this.internalSupplierList[supplier][0].created_at))
          let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          this.minLeadtime = diffDays
          this.maxLeadtime = diffDays

          break

        }
      }
    },
    computeAvgLeadTime () {
      const now = new Date()
      const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      var leadTimeAccumulation = 0
      var leadTimeItem = 0
      var counter = 0
      for (const supplier in this.internalSupplierList){
        if(this.internalSupplierList[supplier].length > 0) {
          for (let i = 0; i < this.internalSupplierList[supplier].length; i++){
            counter += 1
            leadTimeItem = Math.abs(Date.parse(today) - Date.parse(this.internalSupplierList[supplier][i].created_at))
            leadTimeAccumulation = leadTimeAccumulation + leadTimeItem
          }
        }
      }
      if (counter > 0) {
        this.avgLeadtime = leadTimeAccumulation/counter
        this.avgLeadtime = Math.ceil(this.avgLeadtime / (1000 * 60 * 60 * 24))
      }
      else this.avgLeadtime = 0
    },
    computeKbInAndon () {
      this.kanbanAndonList.length = 0
      const now = new Date()
      this.andonKardcounter = 0
      const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      for (const supplier in this.internalSupplierList){
        if(this.internalSupplierList[supplier].length > 0) {
          for (let i = 0; i < this.internalSupplierList[supplier].length; i++){
            if (Date.parse(today) > Date.parse(this.internalSupplierList[supplier][i].delay_ask)) {
              this.andonKardcounter += 1
              let diffTime = Math.abs(Date.parse(today) - Date.parse(this.internalSupplierList[supplier][i].created_at))
              let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              this.internalSupplierList[supplier][i]['leadtime'] = diffDays
              this.kanbanAndonList.push(this.internalSupplierList[supplier][i])
            }
          }
        }
      }
      if (this.kanbanAndonList.length > 0) {
        this.kanbanAndonList.sort(function (a, b) {
          return  b.leadtime - a.leadtime
        })
        if (this.kanbanAndonList.length > 10) {
          this.kanbanAndonList = this.kanbanAndonList.slice(9)
        }
      }
    },
    reatribuate (element) {
      this.internalSupplier = element.internal_supplier
      this.internalCustomer = element.internal_customer
      this.cardNumber = element.card_number
      this.$refs['reatribute-kanban'].showModal()
    },
    clearTable () {
      for (const supplier in this.internalSupplierList) {
        this.internalSupplierList[supplier].length = 0
      }
    },
    splitText (descriptif) {
      return descriptif
    },
    getKanbanCard () {
      server.getKanbanBe((!this.showAllCards) && this.office).then(res => {
        let internalSupplier = ''
        let cardId = ''
        this.clearTable()
        for (let i = 0; i < res.cards.length; i++) {
          internalSupplier = res.cards[i].internal_supplier
          cardId = res.cards[i].reference+'#'+res.cards[i].card_number
          var dataObject = res.cards[i]
          dataObject['cardId'] = cardId
          if (internalSupplier in this.internalSupplierList) {
            this.internalSupplierList[internalSupplier].push(dataObject)
          }
          else {
            if (this.office == 'commerce') {
              this.internalSupplierList['BPER'].push(dataObject)
            }
          }
        }
        this.initiateMinAndMax()
        this.computeAvgLeadTime()
        this.computeKbInAndon()
        this.setProtectedTimeout(this.getKanbanCard, 10000)
      }).catch(function (error) {
        console.log(error)
      })
    },
    exportCSV () {
      server.exportCsvKanbanStat(1).then((response) => {
        let contentDispo = response.headers['content-disposition'].split('filename=')
        contentDispo = contentDispo[1].substring(0, contentDispo[1].length-1)
        saveAs(response.data, contentDispo)
        this.$toasted.success('Données exportées.')
      })
      .catch((e) => {
        this.$toasted.error('Erreur...')
        console.error(e)
      })
    },
    statGraphLeadtime() {
      server.graphKanbanLeadtime(1).then((response) => {
        response.forEach(element => {
          this.dataGraph.series[0].data.push(element.min)
          this.dataGraph.series[1].data.push(element.mean)
          this.dataGraph.series[2].data.push(element.max)
          this.dataGraph.categories.push(element.date)
        });
      })
    },
    statScatterLeadtime() {
      server.graphScatter().then((response) => {
        for (let element in response) {
          let datapush = []
          let date = new Date(response[element].date).getTime()
          datapush.push(date, response[element].kanbanDuration) 
          this.dataScatterGraph.series[0].data.push(datapush)
          }
        this.finishLoop = true
      })
    },
    statMeanLeadTimePeriod() {
      server.statMeanLeadTimePeriod().then((response) => {
        for (let element in response) {
          let startDate = new Date(response[element].startPeriode).getTime()
          this.dataScatterGraph.series[1].data.push([startDate, response[element].meanLeadTime])
        }
      })
    }
  },
  mounted: function () {
    this.internalSupplierList = {}
    this.office = this.$route.params.office
    this.team = this.$route.params.team
    this.statGraphLeadtime()
    this.statMeanLeadTimePeriod()
    this.statScatterLeadtime()
    server.getOfficeTeams().then((result) => {
      for (const supplier of result[this.office][this.team]){
        this.internalSupplierList[supplier] = []
      }
    })
    this.actualVue = 'classic'
    this.getKanbanCard(this.office)
  }
};
</script>

<style>
.vue-simple-context-menu__item.reaf::before {
  content: '\f074';
  font-family: "FontAwesome";
  margin-right: 0.3rem;
}

.vue-simple-context-menu__item.end::before {
  content: '\f046';
  font-family: "FontAwesome";
  margin-right: 0.3rem;
}

.vue-simple-context-menu__item.cancel::before {
  content: '\f187';
  font-family: 'FontAwesome';
  margin-right: 0.3rem;
}
.btn {
  margin-bottom: 2px;
}
#stats-banner {
  padding-top:2%;
  margin-bottom:2rem;
}
.btn-csv {
  margin : 10px 0 0 90%;
}

#andon-list {
  background-color: #f3f3f3;
  height:100%;
  overflow: overlay;
}

.andon-col {
  padding-right: 0px;
  padding-left: 0px;
}

.stats-more {
  display:flex;
  align-items:center;
  justify-content:center;
}

.stats-more p {
  margin-right:1rem;
  font-weight:normal;
  margin-top: revert;
}

#aiopage {
  padding: 5%;
}

.page__background {
  background-color: white !important;
}

label {
  text-align: center;
}

.name-title {
  text-align: center;
}

p {
  font-size: 14px;
  white-space: initial;
  font-weight: bold;
}

.takt-success {
  color: #6ccf46;
}

.takt-mean {
  color: #7f7f7f;
}

.takt-danger {
  color: #e83f35;
}

.number-kb-info {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border-color: #0F6BAF;
  border: 2px solid;
  color: #0F6BAF;
  text-align: center;
  line-height: 2em;
  font-size: 1em;
  margin-left: 1em;
}

.header-list-kb {
  display: flex;
  align-items: center;
  justify-content: center;
}

.middlebox-header{
  text-align:center;
}

.leftbox-header {
  margin: 0.6em 0;
  padding-left: 3rem;
  font-size: 1.2rem;
}
.rightbox-header{
  margin: 0.6em 0;
  padding: 0;
  width: 100px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// KanbanBoard.vue?3d60433c